import axios from "axios";
import { Segment } from "../../../domain/segment/segment";
import {
    Configuration,
    // DomainLeadType,
    ChannelApi as SegmentApi,
    ChannelCreateChannelRequest as SegmentCreateSegmentRequest,
    ChannelChannel as SegmentSegmentResponse
} from "../generated";
import { SegmentInterface } from "../../../useCase/segment/adapters/interface";

/**
 *
 * @export
 * @enum {string}
 */

export const DomainLeadType = {
    Default: 'default',
    Jk: 'jk',
    Avto: 'avto',
    Bank: 'bank'
} as const;

export type DomainLeadType = typeof DomainLeadType[keyof typeof DomainLeadType];

export class SegmentsRepository implements SegmentInterface {
    private service: SegmentApi;

    constructor() {
        this.service = new SegmentApi(new Configuration(), process.env.REACT_APP_BACKEND_URL)
    }

    // async SegmentsListWithCountOfLeadsByDate(date: Date, projectName: string, offset: number, limit: number): Promise<{count: number, segments: Segment[]} | Error> {
    //     try {
    //         let response = await this.service.apiSegmentDateDateGet(date.toISOString(), offset, limit, projectName, { headers: { "Authorization": localStorage.getItem("token") } })
    //
    //         if (response.status === 200) {
    //             let segments: Segment[] = []
    //             response.data?.segments!.forEach((segment) => {
    //                 let item = this.toDomainSegment(segment)
    //                 item.SetLeadsCount(segment.leads_count!)
    //                 segments.push(item)
    //             })
    //             return {count: response.data.count!, segments: segments}
    //         } else {
    //             if (axios.isAxiosError(response)) {
    //                 return Error(response?.message)
    //             }
    //             return Error("something went wrong")
    //         }
    //     } catch (e) {
    //         let error: string = ""
    //         if (axios.isAxiosError(e)) {
    //             error = e.response?.data.message
    //         }
    //
    //         return Error(error)
    //     }
    // }

    async SegmentsList(offset: number | undefined,
                       limit: number | undefined,
                       isActive: boolean | undefined): Promise<{count: number, segments: Segment[]} | Error> {
        try {
            let response = await this.service.apiChannelGet(offset, limit, isActive, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                let segments: Segment[] = []
                response.data?.channels!.forEach((segment) => {
                    let item = this.toDomainSegment(segment)
                    // item.SetLeadsCount(segment.leads_count!)
                    segments.push(item)
                })
                return {count: response.data.count!, segments: segments}
            } else {
                if (axios.isAxiosError(response)) {
                    return Error(response?.message)
                }
                return Error("something went wrong")
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error(error)
        }
    }


    async CreateSegment(body: SegmentCreateSegmentRequest): Promise<Segment | Error> {
        try {
            let response = await this.service.apiChannelPost(body,   { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return this.toDomainSegment(response.data)
            } else {
                if (axios.isAxiosError(response)) {
                    return Error(response?.message)
                }
                return Error("something went wrong")
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error(error)
        }
    }

    async ReadSegmentById(segmentId: string): Promise<Segment | Error> {
        try {
            let response = await this.service.apiChannelIdGet(segmentId,   { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return this.toDomainSegment(response.data)
            } else {
                if (axios.isAxiosError(response)) {
                    return Error(response?.message)
                }
                return Error("something went wrong")
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error(error)
        }
    }

    async UpdateSegmentIntegration(id: string, leadType: string, pipelineId: number, statusId: number, cityId: number, tag: string, utmSource: string, isActive: boolean, autoId: number, homeJkId: number, projectName: string): Promise<Segment | Error> {
        try {
            let ltype;
            switch (leadType) {
                case String(DomainLeadType.Bank):
                    ltype = DomainLeadType.Bank
                    break;
                case String(DomainLeadType.Avto):
                    ltype = DomainLeadType.Avto
                    break;
                case String(DomainLeadType.Jk):
                    ltype = DomainLeadType.Jk
                    break;
                default:
                    ltype = DomainLeadType.Default;
                    break;
            }
            let response = await this.service.apiChannelIdPut(id, {id, lead_type: ltype, pipeline_id: pipelineId, status_id: statusId, city_id: cityId, utm_source: utmSource, tag:tag, is_active: isActive, auto_id: autoId, home_jk_id: homeJkId, name: projectName},   { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return this.toDomainSegment(response.data)
            } else {
                if (axios.isAxiosError(response)) {
                    return Error(response?.message)
                }
                return Error("something went wrong")
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error(error)
        }
    }

    // async ToggleSegmentIntegrationActivity(id: string, active: boolean ): Promise<Segment | Error> {
    //     try {
    //         let response = await this.service.apiSegmentIntegrationIdTogglePut(id, {active: active},   { headers: { "Authorization": localStorage.getItem("token") } })
    //
    //         if (response.status === 200) {
    //             return this.toDomainSegment(response.data)
    //         } else {
    //             if (axios.isAxiosError(response)) {
    //                 return Error(response?.message)
    //             }
    //             return Error("something went wrong")
    //         }
    //     } catch (e) {
    //         let error: string = ""
    //         if (axios.isAxiosError(e)) {
    //             error = e.response?.data.message
    //         }
    //
    //         return Error(error)
    //     }
    // }

    // async UpdateSegmentExportToTz(id: string, firstComment: string, secondComment: string, domainsList: string[], phonesList: string[], alphaList: string[], depth: number, geoRegion: string[], minAge: number, maxAge: number, triggersMinCount: number, limits: number): Promise<Segment | Error> {
    //     try {
    //         let response = await this.service.apiSegmentTzIdPut(id, {first_comment: firstComment, second_comment: secondComment, domains_list: domainsList, phones_list: phonesList,  alpha_list: alphaList, depth: depth, geo_region:geoRegion, min_age: minAge, max_age: maxAge, triggers_min_count: triggersMinCount, limits: limits  },   { headers: { "Authorization": localStorage.getItem("token") } })
    //
    //         if (response.status === 200) {
    //             return this.toDomainSegment(response.data)
    //         } else {
    //             if (axios.isAxiosError(response)) {
    //                 return Error(response?.message)
    //             }
    //             return Error("something went wrong")
    //         }
    //     } catch (e) {
    //         let error: string = ""
    //         if (axios.isAxiosError(e)) {
    //             error = e.response?.data.message
    //         }
    //
    //         return Error(error)
    //     }
    // }

    // async ToggleSegmentExportToTzActivity(id: string, active: boolean ): Promise<Segment | Error> {
    //     try {
    //         let response = await this.service.apiSegmentTzIdTogglePut(id, {active: active},   { headers: { "Authorization": localStorage.getItem("token") } })
    //
    //         if (response.status === 200) {
    //             return this.toDomainSegment(response.data)
    //         } else {
    //             if (axios.isAxiosError(response)) {
    //                 return Error(response?.message)
    //             }
    //             return Error("something went wrong")
    //         }
    //     } catch (e) {
    //         let error: string = ""
    //         if (axios.isAxiosError(e)) {
    //             error = e.response?.data.message
    //         }
    //
    //         return Error(error)
    //     }
    // }

    async DeleteSegment(id: UniqueId): Promise<string | Error> {
        try {
            let response = await this.service.apiChannelIdDelete(id, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return "success"
            } else {
                if (axios.isAxiosError(response)) {
                    return Error(response?.message)
                }
                return Error("something went wrong")
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error(error)
        }
    }

    toDomainSegment(segment: SegmentSegmentResponse): Segment {
        // return new Segment(segment.id!, segment.name!, new Date(segment.created_at!), new Date(segment.updated_at!), segment.is_active!, segment.lead_type!, segment.pipeline_id!, segment.status_id!, segment.city_id!, 0, segment.tag!, segment.utm_source!, segment.is_export_to_tz_active!, segment.first_comment!, segment.second_comment!, segment.depth!, segment.triggers_min_count!, segment.min_age!, segment.max_age!, segment.limits!, segment.alpha_list!, segment. domains_list!, segment.phones_list!, segment.auto_type!, segment.geo_region!)
        return new Segment(segment.id!, segment.name!, new Date(segment.created_at!), new Date(segment.updated_at!), segment.is_active!, segment.lead_type!, segment.pipeline_id!, segment.status_id!, segment.city_id!, 0, segment.tag!, segment.utm_source!, false, "", "", 0, 0, 0, 0, 0, [], [], [], segment.auto_id!, segment.home_jk_id!, [])
    }

}